import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function getAllHierarchyMeta() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETHIERARCHYMETA,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addHierarchyMeta(payload:any) {

  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.AddHIERARCHY, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getParentHierarchy(level:any,isDepartment:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETPARENTHIERARCHY + `?level=${level}&isDepartment=${isDepartment}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateHierarchyMeta(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEHIERARCHY, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteHierarchy(hierarchyId: string) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(urls.DELETEHIERARCHY + hierarchyId, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}